import { useDragLayer } from "react-dnd";
import { useSelector } from "react-redux";
import { selectData } from "@/Redux/Disposition/DispositionReducer";
import BookingLine from "@/Domains/DispositionManagement/Components/DispositionBody/Elements/BookingLine";

//import ManagerDispositionBooking from "../../Views/Manager/SharedViews/Disposition/ManagerDispositionBooking";

function getItemStyles(initialOffset: any, currentOffset: any) {
    if (!initialOffset || !currentOffset) {
        return {
            display: "none",
        };
    }

    let { x, y } = currentOffset;
    x = initialOffset.x;

    const transform = `translate(${0}px, ${y - 233}px)`;

    return {
        transform,
        WebkitTransform: transform,
    };
}

export const CustomDragLayer = () => {
    const data = useSelector((state) => selectData(state));

    const { itemType, isDragging, item, initialOffset, currentOffset } =
        useDragLayer((monitor) => ({
            item: monitor.getItem(),
            itemType: monitor.getItemType(),
            initialOffset: monitor.getInitialSourceClientOffset(),
            currentOffset: monitor.getSourceClientOffset(),
            isDragging: monitor.isDragging(),
        }));

    function renderItem() {
        return (
            <BookingLine
                lineItem={item.booking}
                contentWidth={item.contentWidth}
                setDragDropClass={false}
            />
        );
    }

    if (!isDragging) {
        return null;
    }

    return (
        <div
            style={{
                position: "fixed",
                pointerEvents: "none",
                top: 233,
                bottom: 0,
                overflow: "hidden",
                width: item.contentWidth,
                right: 6,
                zIndex: 100,
            }}
        >
            <div style={getItemStyles(initialOffset, currentOffset)}>
                {renderItem()}
            </div>
        </div>
    );
};
